var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91663 4.5H12.0833M3.91663 8H12.0833M3.91663 11.5H12.0833M13.8333 15H2.16667C1.52409 15 1 14.4759 1 13.8333V2.16667C1 1.52409 1.52409 1 2.16667 1H13.8333C14.4759 1 15 1.52409 15 2.16667V13.8333C15 14.4759 14.4759 15 13.8333 15Z",
    stroke: "#00A3FA",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/activity-icon.b22341b6032fa5e5537ef2f97fa7f7ac.svg";
export { ForwardRef as ReactComponent };